import { isPackaged } from "@lemmonhq/orders";

let activeRequests = 0;
let barEl: HTMLDivElement | null = null;
let styleEl: HTMLStyleElement | null = null;
let hideTimer: ReturnType<typeof setTimeout> | null = null;

function ensureStyle(): void {
  if (styleEl || typeof document === "undefined") return;
  styleEl = document.createElement("style");
  styleEl.textContent = `
    #__routing_progress_bar {
      position: fixed;
      top: 0px;
      left: 10px;
      right: 10px;
      border-radius: 5px;
      height: 4px;
      z-index: 99999;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s ease;
      background: linear-gradient(
        90deg,
        var(--color-primary, #047aff) 0%,
        var(--color-info, #0099e3) 30%,
        var(--color-success, #11b981) 60%,
        var(--color-primary, #047aff) 100%
      );
      background-size: 200% 100%;
      box-shadow: 0 0 10px color-mix(in srgb, var(--color-primary, #047aff) 55%, transparent);
      animation: __routing_shimmer 1.5s linear infinite;
    }
    @keyframes __routing_shimmer {
      from { background-position: 100% 50%; }
      to   { background-position: -100% 50%; }
    }
  `;

  document.head.appendChild(styleEl);
}

function ensureBar(): HTMLDivElement | null {
  if (typeof document === "undefined") return null;
  if (!barEl) {
    ensureStyle();
    barEl = document.createElement("div");
    barEl.id = "__routing_progress_bar";
    document.body.appendChild(barEl);
  }
  return barEl;
}

export function showProgressBar(): void {
  activeRequests++;
  const bar = ensureBar();
  if (!bar) return;
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
  bar.style.opacity = "1";
}

export function hideProgressBar(): void {
  activeRequests = Math.max(0, activeRequests - 1);
  if (activeRequests > 0) return;
  const bar = ensureBar();
  if (!bar) return;
  hideTimer = setTimeout(() => {
    if (bar) bar.style.opacity = "0";
    hideTimer = null;
  }, 150);
}
